"use client";
import { InfoCircleOutlined } from "@ant-design/icons";
import CalendarIcon from "@untitled-ui/icons-react/build/esm/Calendar";
import {
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
  Tooltip,
  Switch,
  Typography,
} from "antd";

import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import dayjs from "dayjs";
import { useEffect } from "react";

const { Text } = Typography;

const Option = Select;

const ProductInformationForm = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    productCategoryOptions,
    currencyOptions,

    issueTypeOptions,
    bondTypeOptions,
    onCurrencyChange,
    checkedActivateWallet,
    checkedAllowTokenization,
    checkedAllowSubWallet,
    setCheckedActivateWallet,
    setCheckedAllowTokenization,
    setCheckedAllowSubWallet,
    productTypeEnum,
    onChangeCurrency,
    useCases,
    externalIdentifiers,
  } = props;

  console.log(productTypeEnum);

  const handleActivateWalletChange = (checked) => {
    setCheckedActivateWallet(checked);
  };

  const handleAllowTokenizationChange = (checked) => {
    setCheckedAllowTokenization(checked);
  };

  const handleAllowSubWalletChange = (checked) => {
    setCheckedAllowSubWallet(checked);
  };

  const selectedCurrency = Form.useWatch("currency", form);

  useEffect(() => {
    if (onCurrencyChange && selectedCurrency) {
      onCurrencyChange(selectedCurrency);
    }
  }, [selectedCurrency]);

  const startOfYear = dayjs().startOf("year");
  const today = dayjs();

  return (
    <div>
      <h1 style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
        Product Information
      </h1>
      <p
        style={{
          color: "#6b7280",
          fontWeight: "400",
          marginBottom: "24px",
          marginTop: 0,
        }}
      >
        Add description text to note for users
      </p>

      <Form
        className="custom-form"
        layout="vertical"
        onFinish={onFinish}
        form={form}
        initialValues={initialValues}
        style={{ width: "100%" }}
      >
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Product Name
                  <Tooltip title="Enter the product name">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="name"
              rules={[
                {
                  required: true,
                  message: "Product Name cannot be empty",
                },
                {
                  min: 3,
                  message: "Product Name cannot be less than 3 characters",
                },
              ]}
            >
              <Input
                className="bond-input"
                style={{ height: 44 }}
                placeholder="Enter product name"
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Product Type
                  <Tooltip title="Select the product type">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="productTypeEnum"
              rules={[
                {
                  required: true,
                  message: "Please select product type",
                },
              ]}
            >
              <Select
                placeholder="Select product type"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={productTypeEnum}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Description
                  <Tooltip title="Select the product type">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="description"
              rules={[
                {
                  required: true,
                  message: "Please select product type",
                },
              ]}
            >
              <Input
                className="bond-input"
                style={{ height: 44 }}
                placeholder="Enter Description"
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Short Name
                  <Tooltip title="Enter the Short name of wallet">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="shortName"
              rules={[
                {
                  required: true,
                  message: "Shortname Name cannot be empty",
                },
                {
                  min: 3,
                  message: "Shortname Name must be 4 character",
                },
              ]}
            >
              <Input
                className="bond-input"
                style={{ height: 44 }}
                placeholder="Enter short name"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Currency
                  <Tooltip title="Select the currency">
                    <InfoCircleOutlined
                      style={{ marginLeft: "4px", color: "#667085" }}
                    />
                  </Tooltip>
                </span>
              }
              name="currencyCode"
              rules={[
                { required: true, message: "Please select product currency" },
              ]}
            >
              <Select
                placeholder="Enter amount"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                showSearch
                onChange={onChangeCurrency}
              >
                {currencyOptions.map((currency) => (
                  <Select.Option key={currency.value} value={currency.value}>
                    {currency.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Use-cases
                  <Tooltip title="Select the use-cases">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="useCases"
              rules={[
                {
                  required: true,
                  message: "Please select use-cases",
                },
              ]}
            >
              <Select
                placeholder="Select use-cases"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={useCases}
                mode="multiple"
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  External Identifier
                  <Tooltip title="Select the external identifier">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="externalIdEnum"
              rules={[
                {
                  required: true,
                  message: "Please select external identifier",
                },
              ]}
            >
              <Select
                placeholder="Select external identifier"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={externalIdentifiers}
                dropdownStyle={{ padding: "5px 0px" }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row
          style={{
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          <Switch
            onClick={props.onSwitchClick}
            checked={checkedActivateWallet}
            onChange={handleActivateWalletChange}
            style={{
              backgroundColor: checkedActivateWallet ? "#b026ff" : "#F2F4F7",
            }}
          />
          <div style={{ width: "60%" }}>
            <Text style={{ marginLeft: 10 }}>Activate Wallet</Text>
            {/* <span>
                      <Tooltip
                        title="A convertible bond gives the bondholder the right to convert the
                          bond into a predetermined number of the issuer’s shares."
                      >
                        <InfoCircleOutlined
                          style={{
                            marginLeft: "4px",
                            color: "#667085",
                          }}
                        />
                      </Tooltip>
                    </span> */}
          </div>
        </Row>{" "}
        <Row
          style={{
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          <Switch
            onClick={props.onSwitchClick}
            checked={checkedAllowTokenization}
            onChange={handleAllowTokenizationChange}
            style={{
              backgroundColor: checkedAllowTokenization ? "#b026ff" : "#F2F4F7",
            }}
          />
          <div style={{ width: "60%" }}>
            <Text style={{ marginLeft: 10 }}>Allow Tokenization</Text>
            {/* <span>
                      <Tooltip
                        title="A convertible bond gives the bondholder the right to convert the
                          bond into a predetermined number of the issuer’s shares."
                      >
                        <InfoCircleOutlined
                          style={{
                            marginLeft: "4px",
                            color: "#667085",
                          }}
                        />
                      </Tooltip>
                    </span> */}
          </div>
        </Row>{" "}
        <div hidden={checkedAllowTokenization ? false : true}>
          <Row
            style={{
              marginTop: 20,
              marginBottom: 20,
            }}
          >
            <Switch
              onClick={props.onSwitchClick}
              checked={checkedAllowSubWallet}
              onChange={handleAllowSubWalletChange}
              style={{
                backgroundColor: checkedAllowSubWallet ? "#b026ff" : "#F2F4F7",
              }}
            />
            <div style={{ width: "60%" }}>
              <Text style={{ marginLeft: 10 }}>
                Allow Sub-Wallet{" "}
                <span style={{ color: "gray", fontSize: "10px" }}>
                  (Virtual Account)
                </span>
              </Text>
              {/* <span>
                      <Tooltip
                        title="A convertible bond gives the bondholder the right to convert the
                          bond into a predetermined number of the issuer’s shares."
                      >
                        <InfoCircleOutlined
                          style={{
                            marginLeft: "4px",
                            color: "#667085",
                          }}
                        />
                      </Tooltip>
                    </span> */}
            </div>
          </Row>
        </div>
        <Form.Item shouldUpdate>
          {() => {
            if (!checkedAllowSubWallet) return null;

            return (
              <Row>
                <Col span={12} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    name="minSubwallet"
                    label="Minimum Sub Wallet"
                    rules={[
                      {
                        required: true,
                        message: "Minimum Sub Wallet cannot be empty",
                      },
                      {
                        validator: (_, value) => {
                          const numberVal = Number(value);
                          if (isNaN(numberVal))
                            return Promise.reject("Must be a number");
                          if (numberVal < 1)
                            return Promise.reject(
                              "Minimum cannot be less than 1",
                            );
                          if (numberVal > 5)
                            return Promise.reject(
                              "Minimum cannot be more than 5",
                            );
                          return Promise.resolve();
                        },
                      },
                    ]}
                    initialValue={1}
                  >
                    <Input
                      type="number"
                      style={{ height: 44 }}
                      className="bond-input"
                      placeholder="Enter Minimum Sub Wallet"
                      disabled
                      min={1}
                      max={1}
                    />
                  </Form.Item>
                </Col>

                <Col span={12} style={{ padding: "0px 8px" }}>
                  <Form.Item
                    label={
                      <span>
                        Maximum Sub Wallet
                        <Tooltip title="Enter the maximum sub wallet">
                          <InfoCircleOutlined
                            style={{
                              marginLeft: "4px",
                              color: "#667085",
                            }}
                          />
                        </Tooltip>
                      </span>
                    }
                    name="maxSubwallet"
                    rules={[
                      {
                        required: true,
                        message: "Maximum Sub Wallet cannot be empty",
                      },
                      {
                        validator: (_, value) => {
                          const num = Number(value);
                          if (!value) {
                            return Promise.reject(
                              "Maximum Sub Wallet is required",
                            );
                          }
                          if (isNaN(num)) {
                            return Promise.reject("Must be a valid number");
                          }
                          if (num < 1) {
                            return Promise.reject(
                              "Maximum Sub Wallet cannot be less than 1",
                            );
                          }
                          if (num > 5) {
                            return Promise.reject(
                              "Maximum Sub Wallet cannot be more than 5",
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                    initialValue={1}
                  >
                    <Input
                      className="bond-input"
                      style={{ height: 44 }}
                      placeholder="Enter Maximum Sub Wallet"
                      type="number"
                      min={1}
                      max={5}
                    />
                  </Form.Item>
                </Col>
              </Row>
            );
          }}
        </Form.Item>
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              name="startDate"
              label="Start Date"
              format="YYYY-MM-DD"
              rules={[
                {
                  required: true,
                  message: "Start date is required",
                },
                {
                  validator: (_, value) => {
                    if (
                      !value ||
                      value.isAfter(startOfYear) ||
                      value.isSame(startOfYear, "day")
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        `Please select a date from ${startOfYear.format(
                          "YYYY-MM-DD",
                        )} onwards`,
                      ),
                    );
                  },
                },
              ]}
            >
              <DatePicker
                className="bond-date-picker"
                size="small"
                style={{
                  width: "100%",
                  height: 44,
                  display: "flex",
                  alignItems: "center",
                  padding: "0 11px",
                  fontSize: 14,
                }}
                format="YYYY-MM-DD"
                suffixIcon={<CalendarIcon color="#667085" width={20} />}
              />
            </Form.Item>
          </Col>

          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              name="endDate"
              label="End Date"
              rules={[
                {
                  required: true,
                  message: `End date is required`,
                },
                () => ({
                  validator(_, value) {
                    if (!value) {
                      return Promise.reject(new Error(`End date is required`));
                    }
                    if (value?.isBefore(today, "day")) {
                      return Promise.reject(
                        new Error(
                          `End date cannot be lesser than ${today.format(
                            "YYYY-MM-DD",
                          )} (Today)`,
                        ),
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <DatePicker
                className="bond-date-picker"
                style={{
                  width: "100%",
                  height: 44,
                  display: "flex",
                  alignItems: "center",
                  padding: "0 11px",
                  fontSize: 14,
                }}
                suffixIcon={<CalendarIcon color="#667085" width={20} />}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ProductInformationForm;
